<template>
  <div data-cy="housing-search-view">
    <EquipmentEditHeader v-if="isAdmin" data-cy="housing-search-view-header" />
    <HousingPumpList data-cy="housing-search-view-list" />
  </div>
</template>

<script setup lang="ts">
import { provide } from "vue";
import EquipmentEditHeader from "@/components/equipment/EquipmentEditHeader.vue";
import { usePumps } from "@/composables/equipment/pumps/pumps";
import HousingPumpList from "./HousingPumpList.vue";
import type { Housings } from "gql/api";

defineEmits<{
  (event: "select", data: Housings): void;
}>();

const pumpsearch = usePumps(true);

// reassign default values for housing page
pumpsearch.title = "Housings";
pumpsearch.searchPlaceholder = "Search By Manufacturer or Series Model...";
pumpsearch.columns = [
  { field: "manufacturer", header: "Manufacturer" },
  { field: "series_model", header: "Pump Series/Model" }
];

provide("equipment", pumpsearch);

const isAdmin = pumpsearch.isAdmin;
</script>
